import React from 'react';

const Page9AwarenessER = ({ 
  erAwareness,
  setErAwareness,
  handlePrevious,
  handleNext 
}) => {
  // Add this function to log the selection before navigating
  const handleNextWithLogging = () => {
    console.log("Page 9 - Selected erAwareness:", erAwareness);
    console.log("Page 9 - erAwareness type:", typeof erAwareness);
    handleNext();
  };

  return (
    <>
      <div className="questions-grid">
        <div className="question-item full-width">
          <label>Are you aware of Cloudphysician's ER Services?</label>
          <div className="rating-options">
            {['Yes', 'No'].map((option) => (
              <div key={option} className="rating-option">
                <label 
                  className={`checkbox-label ${erAwareness === option.toLowerCase() ? 'selected' : ''}`}
                >
                  <input
                    type="radio"
                    name="erAwareness"
                    value={option.toLowerCase()}
                    checked={erAwareness === option.toLowerCase()}
                    onChange={(e) => {
                      console.log("Setting erAwareness to:", e.target.value);
                      setErAwareness(e.target.value);
                    }}
                  />
                  <span>{option}</span>
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="button-group">
        <button className="nav-button" onClick={handlePrevious}>Previous</button>
        <button 
          className="nav-button" 
          onClick={handleNextWithLogging}
          disabled={!erAwareness}
        >
          Next
        </button>
      </div>
    </>
  );
};

export default Page9AwarenessER;
